// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"2e891272","451":"693c7058","649":"5becf5e8","787":"7da95b79","848":"bc5c02ae","895":"948242f5","926":"1b2fa849","972":"c1ed3626","999":"30c0c5fe"}[chunkId] + ".chunk.js";
};